import { burialPointApi, getBaseInfoApi } from '../api/burialPoint';

export default async function burialPoint(params, config) {
  const user_id = JSON.parse(localStorage.getItem('user_id') || '""');
  if (!user_id) {
    const res = await getBaseInfoApi();
    if (res.code === 10000 && res.data && res.data.id) {
      localStorage.setItem('user_id', JSON.stringify(decodeURIComponent(res.data.id || '')));
    }
  }
  return burialPointApi(params, config);
}
